import compileGeneralAdmissionCacheKey
    from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/compilers/compileGeneralAdmission/compileGeneralAdmissionCacheKey';

export default ({ GeneralAdmission }, { payload }) => {
    const { generalAdmissions, status } = payload;
    generalAdmissions.forEach(({ hash }) => {
        const generalAdmission = GeneralAdmission.get({ hash });
        if (generalAdmission) {
            generalAdmission.purchaseStatus = status;
        }

        compileGeneralAdmissionCacheKey(generalAdmission);
    });
};
